import { z } from 'zod';

/**
 * AGM event schemas. The site is multi-year: one event per year, each with its own
 * agenda, locations, logistics, and theme. These validate the event metadata and
 * the per-year theme palette.
 */

export const ColorShadeSchema = z.enum([
  '50',
  '100',
  '200',
  '300',
  '400',
  '500',
  '600',
  '700',
  '800',
  '900',
  '950',
]);

/** A full color ramp — every shade 50–950 must be present. */
export const ColorRampSchema = z.object({
  '50': z.string(),
  '100': z.string(),
  '200': z.string(),
  '300': z.string(),
  '400': z.string(),
  '500': z.string(),
  '600': z.string(),
  '700': z.string(),
  '800': z.string(),
  '900': z.string(),
  '950': z.string(),
});

export const YearThemeSchema = z.object({
  primary: ColorRampSchema,
  accent: ColorRampSchema,
  secondary: ColorRampSchema,
  success: ColorRampSchema,
});

export const EventMetaSchema = z.object({
  year: z.number().int().gte(2000).lte(2100),
  title: z.string().min(1),
  tagline: z.string(),
  displayDate: z.string().min(1),
  city: z.string().min(1),
  venueName: z.string().min(1),
  heroImage: z.string(),
  isCurrent: z.boolean(),
});

export type ColorShade = z.infer<typeof ColorShadeSchema>;
export type ColorRamp = z.infer<typeof ColorRampSchema>;
export type YearTheme = z.infer<typeof YearThemeSchema>;
export type EventMeta = z.infer<typeof EventMetaSchema>;
